import React from 'react';
import { FormHeader, FormFooter, FormBody, Form } from '../../../../modules/Form/styled';
import Buttons from '../../../../modules/Buttons';
import Button from '../../../../components/inputs/Button';
import Icon from '../../../../components/Icon';
import { pathOr } from 'ramda';
import { StyledConfirmWrapper, StyledConfirmItem } from './styled';

const FormConfirm = ({ confirm, onClick }) => {
    return (
        <Form onSubmit={e => e.preventDefault()} noValidate autoComplete="off">
            <FormHeader>
                <Icon name="confirm" />
            </FormHeader>
            <FormBody minHeight={false}>
                <StyledConfirmWrapper>
                    <StyledConfirmItem>{pathOr('', ['confirm_row1'], confirm)}</StyledConfirmItem>
                    <StyledConfirmItem green>{pathOr('', ['confirm_row2'], confirm)}</StyledConfirmItem>
                    <StyledConfirmItem>{pathOr('', ['confirm_row3'], confirm)}</StyledConfirmItem>
                </StyledConfirmWrapper>
            </FormBody>
            <FormFooter>
                <Buttons>
                    <Button
                        onClick={onClick}
                        type='button'
                        fullWidth
                        green
                    >
                        {pathOr('X', ['buttons', 'close'], confirm)}
                    </Button>
                </Buttons>
            </FormFooter>
        </Form>
    )
};

export default FormConfirm;
